import { useState, useEffect, useRef } from "react";

export default function useClickOutsideListner(isVisible: boolean) {
  const [showList, setShowList] = useState<boolean>(isVisible);
  const ref = useRef<any>(null);

  const handleClickOutside = (event: any) => {
    if (ref.current && !ref.current.contains(event.target)) {
      setShowList(false);
    }
  };

  useEffect(() => {
    document.addEventListener("click", handleClickOutside, true);
    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, []);

  return { ref, showList, setShowList };
}
